import React, { useEffect } from "react";
import InfiniteLoader from "react-window-infinite-loader";
import { FixedSizeGrid } from "react-window";
import { PhotoGridProps } from "./types";
import { ThumbnailWidth, ThumbnailHeight } from "./ImageThumbnail2";
import MemoizedCell from "./MemoizedCell";

export const GridHeight = 800;

export const ReactWindowPhotoGrid: React.FC<PhotoGridProps> = ({
  items,
  hasMoreItems,
  areMoreItemsLoading,
  loadMoreItems,
  numColumns = 8,
  width,
  otherProps
}) => {
  const itemsCount =
    hasMoreItems && areMoreItemsLoading
      ? items.length + 2 * numColumns
      : items.length;

  const isItemLoaded = (index: number) => index < items.length;

  const rowCount = Math.ceil(itemsCount / numColumns);
  const height = GridHeight;

  let thewidth = width;
  if (typeof window !== "undefined") {
    let diff = document.body.clientWidth - width;
    diff = isNaN(diff) ? 0 : diff;
    thewidth = width + diff;
  }

  const cellData = {
    items,
    numColumns,
    areMoreItemsLoading,
    thumbnailProps: otherProps.thumbnailProps
  };

  useEffect(() => {
    if (areMoreItemsLoading) {
      document.body.classList.add("footer-hidden-during-scroll-load");
    } else {
      document.body.classList.remove("footer-hidden-during-scroll-load");
    }
  }, [areMoreItemsLoading]);

  return (
    <div className="fixed-size-grid-container react-window-photo-grid">
      <InfiniteLoader
        isItemLoaded={isItemLoaded}
        itemCount={itemsCount}
        loadMoreItems={loadMoreItems}
      >
        {({ onItemsRendered: infiniteOnItemsRendered, ref }) => (
          <FixedSizeGrid
            ref={ref}
            rowCount={rowCount}
            columnCount={numColumns}
            height={height}
            width={thewidth}
            rowHeight={ThumbnailHeight}
            columnWidth={ThumbnailWidth}
            itemData={cellData}
            itemKey={({ rowIndex, columnIndex }) => {
              const index = rowIndex * numColumns + columnIndex;
              const item = items[index];
              return item
                ? `photo-${item.id}-${item.isSelected}`
                : `loading-${index}`;
            }}
            onItemsRendered={({
              visibleRowStartIndex,
              visibleRowStopIndex
            }) => {
              const visibleStartIndex = visibleRowStartIndex * numColumns;
              const visibleStopIndex = visibleRowStopIndex * numColumns;

              infiniteOnItemsRendered({
                overscanStartIndex: visibleStartIndex,
                overscanStopIndex: visibleStopIndex,
                visibleStartIndex: visibleStartIndex,
                visibleStopIndex: visibleStopIndex
              });
            }}
          >
            {MemoizedCell}
          </FixedSizeGrid>
        )}
      </InfiniteLoader>
    </div>
  );
};
